<template>
    <div class="content-full">
        <ui-breadcrumb title="Short codes" :items="['Short Codes']"></ui-breadcrumb>
        <el-row>
            <div class="content">
                <div class="mb-1">
                    <el-row>
                        <el-col :span="18">
                            <el-button size="small" icon="el-icon-delete" type="danger" @click="bulkDelete">Delete</el-button>
                        </el-col>

                        <el-col :span="6">
                            <el-input placeholder="search NO." v-model="filters[0].value"></el-input>
                        </el-col>
                    </el-row>
                </div>
                <el-col :span="24">
                    <data-tables :data="shortCodes" :filters="filters" :action-col="actionCol">
                        <el-table-column type="selection" width="55">
                        </el-table-column>

                        <el-table-column v-for="title in titles" :prop="title.prop" :label="title.label"
                                         :key="title.prop" sortable="custom">
                        </el-table-column>
                    </data-tables>
                </el-col>
            </div>
        </el-row>
    </div>
</template>

<script>
    export default {
        name: "ShortCodes",
        data() {
            return {
                filters: [
                    {
                        prop: ['senderName', 'sender_id'],
                        value: ''
                    }
                ],
                titles: [
                    {
                        prop: 'senderName',
                        label: 'Short Code'
                    },
                    {
                        prop: 'sender_id',
                        label: 'sender ID'
                    },
                    {
                        prop: 'description',
                        label: 'Description'
                    },
                    {
                        prop: 'created_at',
                        label: 'Created On'
                    },
                    {
                        prop: 'productType',
                        label: 'Service Type'
                    }
                ],
                actionCol: {
                    label: 'Actions',
                    props: {
                        align: 'justify',
                    },
                    buttons: [{
                        props: {
                            size: 'mini',
                            type: 'primary',
                            icon: 'el-icon-edit'
                        },
                        handler: row => {
                            console.log(row);
                        }
                    }]
                },
                loading: false,
                shortCodes: []
            };
        },
        mounted() {
            this.getShortCodes();
        },
        methods: {
            bulkDelete() {

            },
            getShortCodes() {
                this.loading = true;
                axios.get('accounts/short-codes').then(response => {
                    this.shortCodes = response.data.data;
                }).finally(() => {
                    this.loading = false;
                })
            }
        }
    }
</script>

<style scoped>

</style>
